// Viewer-role helpers. Coachability is a developmental measure: individual
// results are visible only to the independent coach; org admins (program
// owners) see aggregates + participation. Role comes from the server
// (user.admin via /api/v1/internal/users/me) — never client-side state.

export const ROLE_META = {
  coach: { label: 'Coach', sub: 'Independent consultant', icon: 'target' },
  admin: { label: 'Admin', sub: 'Program owner', icon: 'users' },
};

export function roleFor(user) {
  return user && user.admin ? 'admin' : 'coach';
}

export function canSeeIndividual(role) {
  return role === 'coach';
}
